'use strict';

import React     from 'react';

import { OnSchedUtils } from '../../utils';
import { DeleteAppointment } from '../../actions/appointmentActions';

import Form               from '../Form/Form';
import AppointmentDetails from '../AvailabilityCalendar/AppointmentDetails/AppointmentDetails';



const BookingForm = ({ appointment, element, onschedState, completeAppointment, setBookingAppointment, setAppointment, bookingTimerMins }) => {

  const [bookingForm, setBookingForm] = React.useState(OnSchedUtils.Forms(element, onschedState).BookingForm);

  React.useEffect(() => {
    if (appointment) {
      OnSchedUtils.Loading(element, false);

      let withCustomFields = {
        ...OnSchedUtils.Forms(element, onschedState).BookingForm, 
        ...OnSchedUtils.FormatBookingFields(appointment.appointmentBookingFields),
        // ...OnSchedUtils.FormatBookingFields(appointment.customerBookingFields) // Hide Customer booking fields until we know how to save them
      }

      setBookingForm(withCustomFields);
    }
  }, [appointment]);
  
  const submit = e => {
    e.preventDefault();
    let formInputs = {}

    Array.prototype.slice.call(e.target.children).forEach(child => {
      if (child.className === 'FormColumn') {
        Array.prototype.slice.call(child.children).forEach(formInput => {
          if (formInput.nodeName === 'LABEL') {
            formInputs[formInput.firstChild.name] = formInput.firstChild.checked;
          }
          else {
            formInputs[formInput.name] = formInput.value;
          }
        });
      }
    })

    formInputs.name = formInputs.firstname + ' ' + formInputs.lastname;
    delete formInputs.firstname;
    delete formInputs.lastname;

    const appointmentBookingFields = [];
    const customerBookingFields = [];

    Object.keys(formInputs).map(formInput => {
      const idx = Object.keys(formInputs).indexOf(formInput);

      if (formInput.slice(0, 22) === 'AppointmentCustomField') {
        appointmentBookingFields.push({ name: 'AppointmentCustomField' + formInput.slice(22), value: Object.values(formInputs)[idx] })
        delete formInputs[formInput]
      }
      else if (formInput.slice(0, 11) === 'customField') {
        customerBookingFields.push({ name: 'customField' + formInput.slice(11), value: Object.values(formInputs)[idx] })
        delete formInputs[formInput]
      }
    })

    formInputs.appointmentBookingFields = appointmentBookingFields;
    formInputs.customerBookingFields = customerBookingFields;

    console.log('appointmentBookingFields', appointmentBookingFields, customerBookingFields)
    // console.log('customerBookingFields', customerBookingFields)
    console.log('formInputs', formInputs)
    
    completeAppointment(formInputs)
  }

  const cancel = () => {
    DeleteAppointment(element, appointment.id)
      .then(() => {
        setAppointment(false);
        setBookingAppointment(false);
      });
  }
  
  return (
    <div>
      <AppointmentDetails element={element} appointment={appointment} bookingTimerMins={bookingTimerMins} />
      
      <Form 
        form={bookingForm} 
        submit={submit} 
        cancel={cancel} 
        element={element}
      />
    </div>
  )
};

export default BookingForm;
